import { create } from 'zustand';
import { UserInfo } from './types/userInfo';

interface UserInfoState {
  userInfo: UserInfo;
  chatId: string;
  taskId: string;
  updateUserInfo: (userInfo: Partial<UserInfo>) => void;
  updateChatId: (chatId: string) => void;
  updateTaskId: (taskId: string) => void;
}

const useUserStore = create<UserInfoState>(set => ({
  userInfo: {
    user_tags: [],
    profile_summary: '',
    customer_name: '',
    risk_level: '',
    investment_experience: '',
    total_assets: ''
  },
  chatId: null,
  taskId: null,
  updateChatId: (chatId: string | null) => set({ chatId }),
  updateTaskId: (taskId: string | null) => set({ taskId }),
  updateUserInfo: (userInfo: Partial<UserInfo>) =>
    set(state => ({ userInfo: { ...state.userInfo, ...userInfo } }))
}));

export default useUserStore;
